import ModalPortal from './ModalPortal';

export default ModalPortal;
